// @flow

/***** START WARNING - IF YOU USE THIS CODE WITH MAPBOX MAPPING APIS, REMOVAL OR
 * MODIFICATION OF THE FOLLOWING CODE VIOLATES THE MAPBOX TERMS OF SERVICE  ******
 * The following code is used to access Mapbox's Mapping APIs. Removal or modification
 * of this code when used with Mapbox's Mapping APIs can result in higher fees and/or
 * termination of your account with Mapbox.
 *
 * Under the Mapbox Terms of Service, you may not use this code to access Mapbox
 * Mapping APIs other than through Mapbox SDKs.
 *
 * The Mapping APIs documentation is available at https://docs.mapbox.com/api/maps/#maps
 * and the Mapbox Terms of Service are available at https://www.mapbox.com/tos/
 ******************************************************************************/

import window from '../mapbox-gl-js/src/util/window.js';
import {
    uuid,
    validateUuid,
    storageAvailable,
    warnOnce
} from '../mapbox-gl-js/src/util/util.js';

type SkuTokenObject = {|
  token: string,
  tokenExpiresAt: number
|};

const storageKey = 'mapbox.token.uuid';
const SKU_ID = '03';
// cache the uuid in the file so that it can be retained even without local storage
// it will update per session if local storage is not available
let uuid_ = '';

function tryLocalStorage(cb) {
    if (storageAvailable('localStorage')) {
        try {
            cb();
        } catch (e) {
            warnOnce('Unable to read from LocalStorage');
        }
    }
}

function createSkuToken(): SkuTokenObject {
    // SKU_ID and TOKEN_VERSION are specified by an internal schema and should not change
    const TOKEN_VERSION = '1';
    const base62chars =
    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    // userRandomizer is a randomized 8-digit base-62 number
    let userRandomizer = '';
    for (let i = 0; i < 8; i++) {
        userRandomizer += base62chars[Math.floor(Math.random() * 62)];
    }

    tryLocalStorage(() => {
        uuid_ = window.localStorage.getItem(storageKey);
    });

    if (!validateUuid(uuid_)) {
        uuid_ = uuid();
        tryLocalStorage(() => {
            window.localStorage.setItem(storageKey, uuid_);
        });
    }

    const expiration = 60 * 60 * 1000; // 1 hour
    const token = [
        TOKEN_VERSION,
        SKU_ID,
        userRandomizer,
        uuid_.replace(/-/g, '')
    ].join('');
    const tokenExpiresAt = Date.now() + expiration;

    return {token, tokenExpiresAt};
}

export {createSkuToken, SKU_ID};

/***** END WARNING - REMOVAL OR MODIFICATION OF THE
PRECEDING CODE VIOLATES THE MAPBOX TERMS OF SERVICE  ******/
